import { LitElement, css, html } from 'lit';
import { customElement, property, query } from 'lit/decorators';

import { Checkbox } from '@material/mwc-checkbox';
import { FeatureType } from '../../../types';
import { StateController } from '../../../helpers/state/state-management/state-controller';
import featuresInfo from '../../../helpers/state/features-info';
import topicData from '../../../helpers/state/topic-data';

@customElement('hide-header')
export class HideHeader extends LitElement {
    @property({ type: Boolean })
    open: boolean = false;

    @query('#hideHeader')
    private readonly hideHeaderElement?: Checkbox;

    private readonly bindTopicState = new StateController(this, topicData);

    async updated(changedProperties: Map<string | number | symbol, unknown>) {
        if (changedProperties.has('open')) {
            if (this.hideHeaderElement?.checked !== undefined) {
                this.hideHeaderElement.checked = topicData.topic?.hide_header ?? false;
            }
        }
    }

    async toggleHideHeader(e: Event) {
        const hideHeader = (e.target as HTMLInputElement).checked;

       await topicData.fetchAndUpdateTopicData({
            hide_header: hideHeader
        }, 'hide_header');
    }

    openUpgradeDrawer(featureType: FeatureType) {
        this.dispatchEvent(
            new CustomEvent('open-upgrade-dialog', {
                detail: {
                    featureType
                }
            })
        );
    }

    render() {
        return html`
            <h4 class="helpSubHeader">Hide Header</h4>
            <upgrade-div .feature=${FeatureType.HideHeader} .isLocked=${!featuresInfo.hideHeaderEnabled} .text=${''}>
            <mwc-formfield label="Hide entire map header?">
                <mwc-checkbox
                    id="hideHeader"
                    class="input"
                    @change=${this.toggleHideHeader}
                ></mwc-checkbox>
            </mwc-formfield>
            </upgrade-div>

        `;
    }

    static get styles() {
        return css`
            .input {
                padding: auto 5px;
                display: block;
            }

            .header-text-label {
                margin: 10px 0;
            }

            h4 {
                display: flex;
                align-items: center;
                margin-bottom: 0;
                margin-top: 0;
            }

            .gatedField {
                display: flex;
                flex-direction: column;
                cursor: pointer;
            }

            .menuPng {
                margin-left: 0.25rem;
                height: 20px;
            }
        `;
    }
}
